import { useCallback } from "react"
import { useFeatureFlags } from "./posthog/useFeatureFlags"

export const useAdministrationPath = () => {
  const featureFlags = useFeatureFlags()
  const base = featureFlags.includes("administration-submenu") ? "/administration" : "/organization"

  return useCallback((subPath = "") => `${base}${subPath}`, [base])
}
